<template>
  <div class="pr-6 pb-8 w-full lg:w-1/2 flex flex-wrap">
    <select-input
      v-model="selected_distrik"
      class="pr-6 pb-8 w-full lg:w-1/2"
      :error="errorDistrik"
      label="Nama Distrik"
      :disabled="isReadonly">
      <option :value="null" />
      <option
        v-for="distrik in distriks"
        :key="distrik.id"
        :value="distrik.id">
        {{ distrik.name }}
      </option>
    </select-input>
    <select-input
      v-model="selected_kampung"
      class="pr-6 pb-8 w-full lg:w-1/2"
      :error="errorKampung"
      label="Nama Kampung"
      :disabled="isReadonly">
      <option :value="null" />
      <option
        v-for="kampung in filteredKampungs"
        :key="kampung.id"
        :value="kampung.id">
        {{ kampung.name }}
      </option>
    </select-input>
  </div>
</template>

<script>
import SelectInput from '@/Shared/SelectInput'
import filter from 'lodash/filter'

export default {
  components: {
    SelectInput,
  },
  props: {
    id: {
      type: String,
      default () {
        return `select-input-dk-${this._uid}`
      },
    },
    distriks: Array,
    kampungs: Array,
    isReadonly: {
      type: Boolean,
      default: false,
    },
    errorDistrik: String,
    errorKampung: String,
    valueDistrik: [String, Number, Boolean],
    valueKampung: [String, Number, Boolean],
  },
  data () {
    return {
      selected_distrik: this.valueDistrik,
      selected_kampung: this.valueKampung,
    }
  },
  watch: {
    selected_distrik (selected) {
      this.$emit('input-distrik', selected)
    },
    selected_kampung (selected) {
      this.$emit('input-kampung', selected)
    },
  },
  computed: {
    filteredKampungs () {
      return filter(this.kampungs, ['ref_distrik_id', this.selected_distrik])
    },
  },
}
</script>
